import { render, staticRenderFns } from "./thirdParty.vue?vue&type=template&id=544501a7&scoped=true&"
import script from "./thirdParty.vue?vue&type=script&lang=js&"
export * from "./thirdParty.vue?vue&type=script&lang=js&"
import style0 from "./thirdParty.vue?vue&type=style&index=0&id=544501a7&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "544501a7",
  null
  
)

export default component.exports